export default "__VITE_ASSET__D8DCroHV__"